import { useRole } from "../../RoleContext.js";

export const RoleGate = ({ allowedRoles = [], children }) => {
  const { role } = useRole();
  return allowedRoles.includes(role) ? children : null;
};


